import { render, staticRenderFns } from "./CertificationActionMenuHandlers.vue?vue&type=template&id=1818042e&scoped=true&"
import script from "./CertificationActionMenuHandlers.vue?vue&type=script&lang=js&"
export * from "./CertificationActionMenuHandlers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818042e",
  null
  
)

export default component.exports